module.exports = __webpack_public_path__ + "img/zq5.893900cc.png";